import styled from '@emotion/styled'
import React, { ComponentProps } from 'react'

import HeaderUspBar from '@emico/header-usp-bar'
import { Link } from '@emico/link'
import { overrideOptional } from '@emico/overrides'
import { theme } from '@emico/styles'
import { Container, Logo } from '@emico/ui'

export const Wrapper = styled.header`
  position: sticky;
  top: 0;
  z-index: 1;
`
const StyledBar = styled.div`
  border-bottom: 1px solid ${theme.gray100};
  padding: 10px 0;
`

const Header = (props: ComponentProps<typeof StyledBar>) => (
  <Wrapper>
    <HeaderUspBar />
    <StyledBar {...props}>
      <Container>
        <Link to="/" analyticsContext="header" analyticsName="Logo">
          <Logo />
        </Link>
        {/* TODO: Menu */}
      </Container>
    </StyledBar>
  </Wrapper>
)

export default overrideOptional(Header)
